import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Provider Vetspire';

export const providerVetspireApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'providerVetspireApi',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data.providers,
      query: (data: any) => ({
        method: 'get',
        url: generateUrl(URL.GET_VETSPIRE_PROVIDER_MASTER_LIST, {
          hospital_id: data.id,
        }),
      }),
    }),
  }),
});

export const { useListQuery } = providerVetspireApi;
